// extracted by mini-css-extract-plugin
export var advancedBtn = "ScientistSearch-module--advancedBtn--be0ad";
export var advancedBtnWrap = "ScientistSearch-module--advancedBtnWrap--a9686";
export var disabled = "ScientistSearch-module--disabled--d7037";
export var filter = "ScientistSearch-module--filter--adc11";
export var filterHeader = "ScientistSearch-module--filterHeader--c979c";
export var hitCategory = "ScientistSearch-module--hitCategory--b2571";
export var hitImage = "ScientistSearch-module--hitImage--2cc39";
export var hitLink = "ScientistSearch-module--hitLink--3f91c";
export var menuSelect = "ScientistSearch-module--menuSelect--7460e";
export var refinements = "ScientistSearch-module--refinements--bd7e8";
export var resultWrapper = "ScientistSearch-module--resultWrapper--5c5cf";
export var results = "ScientistSearch-module--results--69c98";
export var resultsInfo = "ScientistSearch-module--resultsInfo--ea3e0";
export var scientistsearch = "ScientistSearch-module--scientistsearch--9d95c";
export var searchContainer = "ScientistSearch-module--searchContainer--68557";